export * from '@primeuix/themes/nora/colorpicker';
export { default } from '@primeuix/themes/nora/colorpicker';
